import React, { useEffect, useState, useContext } from 'react'
import { getImages } from '../Component/const'
import PriceMismatchTable from '../Component/PriceMismatch/PriceMismatchTable'
import ModalLayout from '../Component/Common/ModalLayout'
import FilterModal from '../Component/PriceMismatch/FilterModal'
import SavedSearchesModal from '../Component/PriceMismatch/SavedSearchesModal'
import LoadingModal from '../Component/Common/LoadingModal'
import { VehicleContext } from '../Component/Context/VehicleContext'
import AlertModal from '../Component/Common/AlertModal'
import MobPmtDetails from '../Component/PriceMismatch/MobPmtDetails'

const PriceMismatch = () => {

    const { priceMismatchData, appraisalData, filters, setFilters, getPriceMismatchData, numberFormatter, searchText, setSearchText, getDealershipSoldData, dealershipSold, getMakeModels, makeModelData, getAppraisal, zipCodeData, getVautoAppraisal } = useContext(VehicleContext);

    // Create Note Modal
    const [openFilterModal, setOpenFilterModal] = useState(false);
    const [showAlertModal, setShowAlertModal] = useState(false);
    const handleFilterModal = () => {
        setOpenFilterModal(true);
        document.body.classList.add('overflow-body');
    }
    const closeFilterModal = () => {
        setOpenFilterModal(false);
        document.body.classList.remove('overflow-body');
    }
    const [filterCompleteData, setFilterCompleteData] = useState("");
    const handleRemoveFilter = (filterType, item) => {
        setFilterCompleteData(prevData => {
            if (filterType === 'year' || filterType === 'miles' || filterType === 'dom' || filterType === 'price') {
                // Clear the range by setting it to an empty array
                return {
                    ...prevData,
                    [filterType]: [] // Set the range to an empty array when the "remove" icon is clicked
                };
            } else if (Array.isArray(prevData[filterType])) {
                // Handle array types like 'make' and 'location'
                return {
                    ...prevData,
                    [filterType]: prevData[filterType].filter(val => val !== item)
                };
            } else {
                return {
                    ...prevData
                };
            }
        });
    };

    const handleClearAll = () => {
        setFilters([]);
    };

    // Saved / Edit Searches Modal
    const [openSavedSearchesModal, setOpenSavedSearchesModal] = useState(false);
    const handleSavedSearchesModal = () => {
        setOpenSavedSearchesModal(true);
        document.body.classList.add('overflow-body');
    }
    const closeSavedSearchesModal = () => {
        setOpenSavedSearchesModal(false);
        document.body.classList.remove('overflow-body');
    }

    const nextYear = (new Date().getFullYear()) + 1;

    const sliderParams = {
        year: {
            min: 1980,
            max: nextYear,
            defaultBottom: 2007,
            defaultTop: nextYear,
            thousands: false
        },
        miles: {
            min: 0,
            max: 200,
            defaultBottom: 0,
            defaultTop: 30,
            thousands: true
        },
        dom: {
            min: 0,
            max: 365,
            defaultBottom: 45,
            defaultTop: 365,
            thousands: false
        },
        price: {
            min: 0,
            max: 250,
            defaultBottom: 60,
            defaultTop: 250,
            thousands: true
        },
        zip: {
            min: 0,
            max: 201,
            defaultBottom: 0,
            defaultTop: 50
        }
    };

    const [editItemValues, setEditItemValues] = useState({
        "make": [],
        "year_min": sliderParams.year.defaultBottom,
        "year_max": sliderParams.year.defaultTop,
        "miles_min": sliderParams.miles.defaultBottom * 1000,
        "miles_max": sliderParams.miles.defaultTop * 1000,
        "dom_min": sliderParams.dom.defaultBottom,
        "dom_max": sliderParams.dom.defaultTop,
        "price_min": sliderParams.price.defaultBottom * 1000,
        "price_max": sliderParams.price.defaultTop * 1000,
        "zipCode": "",
        "milesZipCode": [sliderParams.zip.defaultBottom, sliderParams.zip.defaultTop],
        "oem_dealer": true
    });

    const handleSaveEdit = (editItem) => {
        setOpenFilterModal(true);
        setEditItemValues(editItem);
    }
    // Delete Saved Data
    const handleDelete = (id) => {
        const storedData = localStorage.getItem("filterCompleteData");
        if (storedData) {
            const dataArray = JSON.parse(storedData);
            const updatedData = dataArray.filter(item => item.id !== id);
            localStorage.setItem("filterCompleteData", JSON.stringify(updatedData));
            setEditItemValues({});
            console.log(`Item with id ${id} has been deleted.`);
        } else {
            console.log("No data found in localStorage.");
        }
    };

    const convertToCSV = (objArray) => {
        const array = typeof objArray !== 'object' ? JSON.parse(objArray) : objArray;
        let str = '';

        let header = '';
        for (let index in array[0]) {
            if (header !== '') header += ',';

            header += index;
        }

        str += header + '\r\n';

        for (let i = 0; i < array.length; i++) {
            let line = '';
            for (let index in array[i]) {
                if (line !== '') line += ',';

                line += '"' + array[i][index] + '"';
            }
            str += line + '\r\n';
        }
        return str;
    };

    const downloadCSV = () => {
        const csvData = new Blob([convertToCSV(priceMismatchData)], { type: 'text/csv' });
        const csvURL = URL.createObjectURL(csvData);
        const link = document.createElement('a');
        link.href = csvURL;
        link.download = `price_mismatch.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    const handleSearchChange = (e) => {
        setSearchText(e.target.value);
    };

    const [loadingPage, setLoadingPage] = useState(true);

    const [currentPage, setCurrentPage] = useState(1);

    const fetchData = async (params) => {
        setLoadingPage(true);

        setCurrentPage(1);

        await getPriceMismatchData(params);

        setLoadingPage(false);

    };

    useEffect(() => {
        console.log("current filters", editItemValues);

        var queryParams = {};

        Object.entries(editItemValues).map(([i, v]) => {
            if (i in sliderParams) {
                queryParams[i + "_min"] = v[0] * (sliderParams[i].thousands ? 1000 : 1);
                queryParams[i + "_max"] = v[1] == sliderParams[i].max ? 9999999 : v[1] * (sliderParams[i].thousands ? 1000 : 1);
            } else
                queryParams[i] = v;
        });
        console.log("queryParams", queryParams)
        fetchData(queryParams);
    }, [editItemValues]);

    useEffect(() => {
        getMakeModels();
    }, []);

    const [isWholesale, setIsWholesale] = useState(false);

    const handlePriceBtn = () => {
        setIsWholesale((prev) => !prev);
    };

    // For Tab View
    const [isTabView, setIsTabView] = useState(window.innerWidth < 992);
    useEffect(() => {
        const handlePmResize = () => {
            setIsTabView(window.innerWidth < 992);
        };
        window.addEventListener('resize', handlePmResize);
        handlePmResize();
        return () => window.removeEventListener('resize', handlePmResize);
    }, []);

    // 
    const [openMobPmtModal, setOpenMobPmtModal] = useState(false);
    const [mobPmtData, setMobPmtData] = useState("");
    const handleMobPmtData = (currentitem) => {
        setMobPmtData(currentitem);
        setOpenMobPmtModal(true);
        document.body.classList.add('overflow-active');
    }
    const closeMobPmtModal = () => {
        setMobPmtData("");
        setOpenMobPmtModal(false);
        document.body.classList.remove('overflow-active');
    }
    return (
        <>
            {/* {console.log("filters", filters)} */}
            <div className='main-card'>

                <div className='mob-va-block'>

                    {isTabView && (
                        <>
                            <div className='d-flex align-items-center justify-content-between mb-3'>
                                <div className='sm-title text-uppercase font-1-2em'>
                                    Price Mismatches
                                    <div className="tooltip-container info-msg">
                                        <img className="ico_info" src={getImages('red-ico-info.svg')} />
                                        <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                                    </div>
                                </div>
                                <div>
                                    <button type='button' className='filter-btn text-start mob-pm-filter-btn' onClick={handleFilterModal}>
                                        <img  src={getImages('filter-font-awesome.png')} alt='filter' /> Filters
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                    <div className='d-lg-flex align-items-center justify-content-between mb-3 pmf-flex'>
                        <div>
                            <div className='d-flex search-flex'>
                                <input type='text' className='form-control' placeholder='Search' value={searchText} onChange={handleSearchChange} />
                                <button type='button' className='search-btn'>
                                    <img src={getImages('icon-search.svg')} alt='search' />
                                </button>
                            </div>
                        </div>

                        {!isTabView && (
                            <>
                                <div>
                                    <button type='button' className='save-search-btn transparent-btn' onClick={handleSavedSearchesModal}>
                                        <img className='me-2' src={getImages('save-material.svg')} alt='save' /> Saved Searches
                                    </button>
                                    <button type='button' className='export-excel-btn transparent-btn' onClick={downloadCSV}>
                                        <img className='me-2' src={getImages('icon-file-download.svg')} alt='download' /> Export to Excel
                                    </button>
                                    <button type='button' className='filter-btn text-start' onClick={handleFilterModal}>
                                        <img className='me-4 ms-2' src={getImages('filter-font-awesome.png')} alt='filter' /> Filters
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                    <div className='d-flex align-items-center mb-lg-3 flex-wrap filter-tags'>
                        {filters.year_min && filters.year_max && (
                            <span className='search-tag d-inline-block'>
                                Year {filters.year_min} - {filters.year_max == sliderParams.year.max || filters.year_max == 9999999 ? "max" : filters.year_max}
                                <img
                                    src={getImages('icon-exit.svg')}
                                    alt="Remove"
                                    onClick={() =>
                                        setFilters(prevFilters => ({
                                            ...prevFilters,
                                            year_min: '',
                                            year_max: ''
                                        }))
                                    }
                                />
                            </span>
                        )}
                        {filters.dom_min && filters.dom_max && (
                            <span className='search-tag d-inline-block'>
                                Miles {filters.miles_min} - {filters.miles_max == sliderParams.miles.max * 1000 || filters.miles_max == 9999999 ? "max" : filters.miles_max}
                                <img
                                    src={getImages('icon-exit.svg')}
                                    alt="Remove"
                                    onClick={() =>
                                        setFilters(prevFilters => ({
                                            ...prevFilters,
                                            miles_min: '',
                                            miles_max: ''
                                        }))
                                    }
                                />
                            </span>
                        )}
                        {filters.dom_min && filters.dom_max && (
                            <span className='search-tag d-inline-block'>
                                DOM {filters.dom_min} - {filters.dom_max == sliderParams.dom.max || filters.dom_max == 9999999 ? "max" : filters.dom_max}
                                <img
                                    src={getImages('icon-exit.svg')}
                                    alt="Remove"
                                    onClick={() =>
                                        setFilters(prevFilters => ({
                                            ...prevFilters,
                                            dom_min: '',
                                            dom_max: ''
                                        }))
                                    }
                                />
                            </span>
                        )}
                        {filters.price_min && filters.price_max && (
                            <span className='search-tag d-inline-block'>
                                Price {numberFormatter(filters.price_min, true)} - {filters.price_max == sliderParams.price.max * 1000 || filters.price_max == 9999999 ? "max" : numberFormatter(filters.price_max, true)}
                                <img
                                    src={getImages('icon-exit.svg')}
                                    alt="Remove"
                                    onClick={() =>
                                        setFilters(prevFilters => ({
                                            ...prevFilters,
                                            price_min: '',
                                            price_max: ''
                                        }))
                                    }
                                />
                            </span>
                        )}
                        {Object.entries(filters)
                            .filter(([key]) => key.startsWith('make'))
                            .map(([key, value]) => (
                                <span className='search-tag d-inline-block' key={key}>
                                    {value}
                                    <img
                                        src={getImages('icon-exit.svg')}
                                        alt="Remove"
                                        onClick={() =>
                                            setFilters(prevFilters => {
                                                const updatedFilters = { ...prevFilters };
                                                delete updatedFilters[key];
                                                return updatedFilters;
                                            })
                                        }
                                    />
                                </span>
                            ))}
                        {Object.entries(filters)
                            .filter(([key]) => key.startsWith('model'))
                            .map(([key, value]) => (
                                <span className='search-tag d-inline-block' key={key}>
                                    {value}
                                    <img
                                        src={getImages('icon-exit.svg')}
                                        alt="Remove"
                                        onClick={() =>
                                            setFilters(prevFilters => {
                                                const updatedFilters = { ...prevFilters };
                                                delete updatedFilters[key];
                                                return updatedFilters;
                                            })
                                        }
                                    />
                                </span>
                            ))}
                        {/*filters && <button type='button' className='clear-all-btn' onClick={handleClearAll}>Clear All</button>*/}

                    </div>

                    {isTabView && (
                        <>
                            {/* {filters.zipCode &&
                                <div className='d-inline-block xsm-title'><img src={getImages('icon-pin.png')} />
                                    <span className='fw-700 text-white ps-2'>{filters.milesZipCode}</span> miles from <span className='fw-700 text-red'>{filters.zipCode}</span>
                                </div>
                            } */}
                            <div className='d-inline-block xsm-title'>
                                <img src={getImages('icon-pin.png')} />
                                <span className='fw-700 text-white ps-2'>200 </span> 
                                miles from 
                                <span className='fw-700 text-red'> 11803</span>
                            </div>
                        </>
                    )}
                </div>

                {isTabView && (
                    <>
                        <div className='d-flex align-items-center justify-content-between mob-custom-tab-th mb-1'>
                            <div>Vehicle Info</div>
                            <div className='pe-5'>Dealership</div>
                        </div>
                    </>
                )}
                <div className='common-box-border mob-pmt-box'>
                    {!isTabView && (
                        <>
                            <div className='d-flex align-items-center mb-1'>
                                <div className='sm-title text-uppercase w-40'>
                                    Price Mismatches
                                    <div className="tooltip-container info-msg">
                                        <img className="ico_info" src={getImages('red-ico-info.svg')} />
                                        <div className="tooltip-box">Lorem Ipsum is simply dummy text of the printing and typesetting industry</div>
                                    </div>
                                </div>
                                <div className='d-inline-block me-5 pe-5'>
                                    <button className='red-transparent-btn text-uppercase d-inline-block text-nowrap wholesale-price-btn mnw-210' type='button' onClick={handlePriceBtn}>
                                        {'Wholesale/Retail'}
                                        <img className='ms-4' src={getImages('loop-material.png')} />
                                    </button>
                                </div>
                                {filters.zipCode && <div className='d-inline-block location-box xsm-title'><img src={getImages('icon-pin.png')} />
                                    <span className='fw-700 text-white'>{filters.milesZipCode}</span> miles from <span className='fw-700 text-red'>{filters.zipCode}</span>
                                </div>}
                            </div>
                        </>
                    )}
                    {/* {console.log("priceMismatchData First", priceMismatchData)} */}
                    {priceMismatchData &&
                        <PriceMismatchTable
                            priceMismatchData={priceMismatchData}
                            appraisalData={appraisalData}
                            numberFormatter={numberFormatter}
                            getDealershipSoldData={getDealershipSoldData}
                            dealershipSold={dealershipSold}
                            isWholesale={isWholesale}
                            getAppraisal={getAppraisal}
                            zipCodeData={zipCodeData}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            getVautoAppraisal={getVautoAppraisal}
                            isTabView={isTabView}
                            handleMobPmtData={handleMobPmtData}
                        />
                    }
                </div>
            </div>
            {openMobPmtModal &&
                <MobPmtDetails
                    close={closeMobPmtModal}
                    mobPmtData={mobPmtData}
                    openMobPmtModal={openMobPmtModal}
                    filters={filters}
                    handlePriceBtn={handlePriceBtn}
                    numberFormatter={numberFormatter}
                    appraisalData={appraisalData}
                    isWholesale={isWholesale}
                />
            }
            {loadingPage &&
                <ModalLayout open={loadingPage} close={closeFilterModal} modalWidth={550} darkThemeCls="true">
                    <LoadingModal />
                </ModalLayout>
            }
            {openFilterModal && makeModelData &&
                <ModalLayout
                    open={openFilterModal}
                    close={closeFilterModal}
                    modalWidth={1198}
                    darkThemeCls="true"
                    pmFilterModal="pricemismatch-filter-modal"
                >
                    <FilterModal
                        close={closeFilterModal}
                        setFilterCompleteData={setFilterCompleteData}
                        editItemValues={editItemValues}
                        filterCompleteData={filterCompleteData}
                        setOpenSavedSearchesModal={setOpenSavedSearchesModal}
                        setEditItemValues={setEditItemValues}
                        sliderParams={sliderParams}
                        makeModelData={makeModelData}
                    />
                </ModalLayout>
            }
            {openSavedSearchesModal &&
                <ModalLayout open={openSavedSearchesModal} close={closeSavedSearchesModal} modalWidth={1198} darkThemeCls="true">
                    <SavedSearchesModal
                        close={closeSavedSearchesModal}
                        setOpenFilterModal={setOpenFilterModal}
                        handleSaveEdit={handleSaveEdit}
                        handleDelete={handleDelete}
                        openSavedSearchesModal={openSavedSearchesModal}
                        setEditItemValues={setEditItemValues}
                    />
                </ModalLayout>
            }
            {showAlertModal &&
                <ModalLayout open={showAlertModal} modalWidth={550} darkThemeCls="true">
                    <AlertModal setShowAlertModal={setShowAlertModal} />
                </ModalLayout>
            }
        </>
    )
}

export default PriceMismatch